import React from "react";
import CategoryText from "./category-text";
import "@fontsource/roboto/300.css";

export default function PostTitle({ title, subtitle, category }) {
  return (
    <div className="flex flex-col items-center justify-center space-y-2">
      <div className="flex space-x-6 sm:space-x-8">
        <span className="top-0 border-primary border-b w-12 sm:w-20 h-4"></span>
        <CategoryText
          type="h2"
          className="relative uppercase text-primary font-light"
        >
          {category}
        </CategoryText>
        <span className="top-0 border-primary border-b w-12 sm:w-20 h-4"></span>
      </div>

      <h1 className="max-w-lg text-primary uppercase text-center text-5xl">
        {title}
      </h1>

      <h2 className="text-center text-xl">{subtitle}</h2>
    </div>
  );
}
